import React from 'react';
import {
    Block,
    Button,
    Card,
    Col,
    Dialog,
    DialogBody,
    DialogFooter,
    LabelValue,
    List,
    ListItem,
    makeValidate,
    ModalComponentProps,
    Row,
    Space,
    Spinner,
    Text,
    VF,
    Yup,
} from '@mc/ui-v4';
import {Form, FormRenderProps} from 'react-final-form';
import {ActionConfigVO, FulltextSearchResultVO, LayerSettingsApi} from '../../../api';
import {OnChange} from 'react-final-form-listeners';
import {printFormatterFulltextSearchResultVO, printFormatterUredniOsobaNazevEOS} from '../../../helpers/Formatter';
import {actionApiCall} from '@mc/react-app-v4';
import {getTypAkceCaption} from '../../../enums/EnumTypAkce';

export function renderUsersOfEntity(entita: FulltextSearchResultVO) {
    return (
        <>
            {entita && entita.type !== 'PRACOVNIK' && (
                <LabelValue label={`Uživatelé ${entita.type === 'ORG_JEDNOTKA' ? 'organizační jednotky' : 'organizační role'}`}>
                    <List mode={'input'}>
                        {(entita.type === 'ORG_JEDNOTKA' ? entita.organizacniJednotka.pracovnici : entita.organizacniRole.pracovnici).map((pracovnik, key) => {
                            return <ListItem key={key}>{`${printFormatterUredniOsobaNazevEOS(pracovnik)}`}</ListItem>;
                        })}
                    </List>
                </LabelValue>
            )}
        </>
    );
}

type Props = ModalComponentProps & {
    initialValues?: SingleOpravneniProps;
    layerLabel: string;
    onSubmit: (data: SingleOpravneniProps) => void;
    akce?: ActionConfigVO[];
};

export type SingleOpravneniProps = {
    vlastnikVrstvy?: boolean;
    entita?: FulltextSearchResultVO;
    actionList?: ActionConfigVO[];
    showWarning?: boolean;
};
export const OpravneniModal: React.FC<Props> = ({onClose, initialValues, onSubmit, layerLabel, akce}) => {
    const validateSchema = Yup.object().shape({
        entita: Yup.object().required('Entita je povinná'),
    });
    const validation = makeValidate(validateSchema);

    return (
        <Form<SingleOpravneniProps>
            initialValues={initialValues}
            onSubmit={onSubmit}
            validate={async data => {
                return await validation(data);
            }}
        >
            {({submitting, handleSubmit, values, form: {change}}: FormRenderProps<SingleOpravneniProps>) => {
                const checkAction = (isChecked: boolean, akceItem: ActionConfigVO) => {
                    if (isChecked) {
                        change(
                            'actionList',
                            values.actionList?.filter(item => item.id !== akceItem.id),
                        );
                    } else {
                        change('actionList', [...values.actionList, akceItem]);
                    }
                };

                const changeVlastnik = value => {
                    change('actionList', value ? akce : []);
                };

                return (
                    <Dialog size="md" onClose={onClose} title={`Oprávnění vrstvy - ${layerLabel}`}>
                        {submitting && (
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            >
                                <Spinner />
                            </div>
                        )}
                        <DialogBody>
                            <Space vertical>
                                <Card mode={'edit'}>
                                    <Block>
                                        <Row>
                                            <Col>
                                                <VF.Autocomplete
                                                    onSearchItems={async text =>
                                                        await actionApiCall(async () => (await LayerSettingsApi.getAllEntitiesFulltext(text)).data)
                                                    }
                                                    getItemName={(item: FulltextSearchResultVO) => {
                                                        return item ? printFormatterFulltextSearchResultVO(item) : '';
                                                    }}
                                                    label={'Entita'}
                                                    name={'entita'}
                                                />
                                            </Col>
                                            <Col xs={'auto'} className={'mt-auto'}>
                                                <VF.Checkbox label={'Vlastník vrstvy'} name={'vlastnikVrstvy'} />
                                                <OnChange name={'vlastnikVrstvy'}>{changeVlastnik}</OnChange>
                                            </Col>
                                        </Row>
                                        <LabelValue label={'Oprávnění'}>
                                            <List mode={'input'}>
                                                <ListItem disabled checked checkable>
                                                    Prohlížení vrstvy
                                                </ListItem>
                                                {akce.map((akceItem, key) => {
                                                    const isChecked = values.actionList?.some(valuesAkce => akceItem.id === valuesAkce.id);
                                                    return (
                                                        <ListItem
                                                            key={key}
                                                            checkable
                                                            rowCheck
                                                            onCheck={() => values.vlastnikVrstvy || checkAction(isChecked, akceItem)}
                                                            checked={values.vlastnikVrstvy || isChecked}
                                                            disabled={submitting || values.vlastnikVrstvy}
                                                        >
                                                            {`${akceItem.nazev}  (${getTypAkceCaption(akceItem.typ)})`}
                                                        </ListItem>
                                                    );
                                                })}
                                            </List>
                                        </LabelValue>
                                        {renderUsersOfEntity(values.entita)}
                                        {values.showWarning && (
                                            <Text className={'textInfo ml-2'} type={'block'} intent={'warning'}>
                                                Promítnutí oprávnění může trvat několik minut.
                                            </Text>
                                        )}
                                    </Block>
                                </Card>
                            </Space>
                        </DialogBody>
                        <DialogFooter>
                            <Button style="default" onClick={onClose} disabled={submitting}>
                                Zrušit
                            </Button>
                            <Button
                                style="primary"
                                onClick={e => {
                                    change('showWarning', true);
                                    setTimeout(handleSubmit, 1000);
                                }}
                                disabled={submitting}
                            >
                                Uložit
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
